import { async } from '@angular/core/testing';
import { Component, OnInit, ElementRef, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, ViewChildren, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA, MatTabChangeEvent } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { ReplaySubject, fromEvent, merge, BehaviorSubject } from 'rxjs';
//Datasource
import { KhoXuatKhoPageDataSource } from '../kho-xuat-kho-page-datasource/kho-xuat-kho.datasource';
//Service
import { KhoXuatKhoPageService } from '../kho-xuat-kho-page-service/kho-xuat-kho-page.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, QueryParamsModel, MessageType } from '../../../../../../core/_base/crud';
//import {KhoXuatKhoEditComponent } from '../kho-xuat-kho-edit/kho-xuat-kho-edit.component';
//import {KhoXuatKhoDuyetComponent } from '../kho-xuat-kho-duyet/kho-xuat-kho-duyet.component';
import { environment } from '../../../../../../../environments/environment';
//Model
import { ConstantsExport, KhoXuatKho, KhoXuatKhoChiTiet, KhoXuatKhoDeNghi } from '../kho-xuat-kho-page-model/kho-xuat-kho-page.model';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { roundWithPrecision } from 'chartist';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { DynamicSearchFormService } from 'app/views/pages/components/dynamic-search-form/dynamic-search-form.service';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import moment from 'moment';
import { element } from 'protractor';
@Component({
	selector: 'm-kho-xuat-kho-page-dsdn',
	templateUrl: './kho-xuat-kho-page-dsdn.component.html',
	styleUrls: ['../kho-xuat-kho-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DatePipe]
})
export class KhoXuatKhoPageDSDNComponent implements OnInit {
	/*Config Form */
	CONFIG: CommonConFig;
	// Table fields
	dataSource: KhoXuatKhoPageDataSource;
	dataSource2: KhoXuatKhoPageDataSource;
	dataSource3: KhoXuatKhoPageDataSource;
	displayedColumns = [];
	availableColumns = [
		{
			stt: 1,
			name: 'onoff',
			displayName: '',
			alwaysChecked: true,
			isShow: true
		},
		{
			stt: 1,
			name: 'select',
			displayName: '',
			alwaysChecked: true,
			isShow: true
		},
		{
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: true,
			isShow: true
		},
		{
			stt: 1,
			name: 'MAHANG',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 2,
			name: 'TENHANG',
			displayName: 'Tên hàng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'LOAIPHIEU',
			displayName: 'Loại phiếu ĐNXK',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 3,
			name: 'DVT',
			displayName: 'ĐVT',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 4,
			name: 'QUYCACH',
			displayName: 'Quy cách',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 12,
			name: 'SOLUONG',
			displayName: 'Số lượng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 12,
			name: 'SOLUONGTHUCXUAT',
			displayName: 'Số lượng thực xuất',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 5,
			name: 'MUCDICHSUDUNG',
			displayName: 'Mục đích sử dụng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'NGAYCAN',
			displayName: 'Ngày cần',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'PBDN',
			displayName: 'Phòng ban đề nghị',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'KVSX',
			displayName: 'Khu vực sản xuất',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'SOPHIEUDNXK',
			displayName: 'Số phiếu đề nghị xuất kho',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'NGAYLAPPHIEUDNXK',
			displayName: 'Ngày lập phiếu DNXK',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'GHICHU',
			displayName: 'Ghi chú',
			alwaysChecked: false,
			isShow: true
		},
	];
	@ViewChildren('focus') focus;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild('sort1', { static: true }) sort: MatSort;
	@ViewChild('sort2', { static: true }) sort2: MatSort;
	@ViewChild('sort3', { static: true }) sort3: MatSort;
	@ViewChild('searchFullText', { static: true }) searchFullText: ElementRef;
	@ViewChild('trigger', { static: true }) _trigger: MatMenuTrigger;
	// Filter fields
	// @ViewChild('searchTuNgay', {static: true}) searchTuNgay: ElementRef;
	// @ViewChild('searchDenNgay', {static: true}) searchDenNgay: ElementRef;
	minDate: string = "";
	maxDate: string = "";
	@ViewChild('keywordSearch', { static: true }) keywordSearch: ElementRef;
	isZoomSize: boolean = false;
	// Selection
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selectionPDN = new SelectionModel<KhoXuatKhoDeNghi>(true, []);
	KhoXuatKhoResult: KhoXuatKhoDeNghi[] = [];
	tmpKhoXuatKhoResult: KhoXuatKhoDeNghi[] = [];
	KhoXuatKhoResult2: KhoXuatKhoDeNghi[] = [];
	tmpKhoXuatKhoResult2: KhoXuatKhoDeNghi[] = [];
	KhoXuatKhoResult3: KhoXuatKhoDeNghi[] = [];
	tmpKhoXuatKhoResult3: KhoXuatKhoDeNghi[] = [];
	listDDHDaChon: KhoXuatKhoChiTiet[] = [];
	dsDDHDaChon: KhoXuatKhoDeNghi[] = [];
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	viewLoading: boolean = false;
	saveNewTTHV: number[] = []
	flagHighlight: boolean = false;
	previousIndex: number;
	fixedPoint = 2;
	__back = true;
	isXuatDiXuLy: boolean = false;
	LIST_ROLES_USER: [] = [];
	list = new BehaviorSubject<KhoXuatKhoDeNghi>(new KhoXuatKhoDeNghi());
	//filter on grid
	down: any;
	top: any;
	haveFilter: boolean = false;
	filterGroupDataChecked: any = {};
	filterGroupDataCheckedFake: any = {};
	filterGroupData: any = {};
	filterGroupArray: any = {};
	filterText: any = {};
	tmpfilterText: any = {};
	disableButtonFilter: any = {};
	isClearAll: boolean = false;
	IdNCC = '';
	isChange: boolean = false;
	saveAddedTTHV: number[] = [];
	checkAllRecord: boolean = false;
	listHangHoaDaChon: KhoXuatKhoDeNghi[] = [];
	allRecordSelect: KhoXuatKhoDeNghi[] = [];
	showAll: boolean = false;
	edit: boolean = false;
	actionDialogDenghi: boolean = false;
	danhSachId = [];
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.key == "Escape") {
			this.back();
		}
	}
	optionLoaiPhieu = [];
	sortDirection = "desc";
	sortProperty = "NGAYLAPPHIEUDNXK";
	flagTab = 0;
	loading: boolean = false;
	openSearch: boolean = false;
	kwSearch: string = "";
	loading2: boolean = false;
	loading3: boolean = false;
	TAB_INTERNAL_EXPORT = ConstantsExport.TAB_INTERNAL_EXPORT;
	TAB_SELL_EXPORT = ConstantsExport.TAB_SELL_EXPORT;
	TAB_SUPPLIER_EXPORT = ConstantsExport.TAB_SUPPLIER_EXPORT;
	constructor(
		private KhoXuatKhoService: KhoXuatKhoPageService,
		private dungChungService: DungChungService,
		public dialog2: MatDialog,
		private route: ActivatedRoute,
		private router: Router,
		private datePipe: DatePipe,
		private translate: TranslateService,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		public dialogRef2: MatDialogRef<KhoXuatKhoPageDSDNComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private layoutUtilsService: LayoutUtilsService,
		private dynamicSearchFormService: DynamicSearchFormService,) {
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		this.LIST_ROLES_USER = user.roles;
		this.dialogRef2.disableClose = true;
		this.flagTab = Number(this.data.tab);
		console.log(this.data);
	}
	/** LOAD DATA */
	ngOnInit() {
		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.CONFIG.PAGE_SIZE_LIST = environment.pageSize;
		//this.selectionPDN.clear();
		this.actionDialogDenghi = this.data.actionDialogDenghi;
		this.danhSachId = this.data.danhSachId;
		this.isXuatDiXuLy = this.data.xuatHangDiXuLy == '13' ? true : false;
		//this.getNumberRecordHoanTat();
		//this.dsDDHDaChon = this.data.list;
		this.dialogRef2.keydownEvents().subscribe(event => {
			if (event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.TIEPTUC.KeyCombine.keycode && this.listHangHoaDaChon.length > 0) {
				this.addPhieuDeNghiCT();
			}
		});
		this.haveFilter = true;
		this.disableButtonFilter['MaHang'] = true;
		this.disableButtonFilter['TenHang'] = true;
		this.disableButtonFilter['MucDichSuDung'] = true;
		this.disableButtonFilter['SoPhieuDNXK'] = true;
		this.filterText['MaHang'] = "";
		this.filterText['TenHang'] = "";
		this.filterText['MucDichSuDung'] = "";
		this.filterText['TuNgayNgayCan'] = "";
		this.filterText['DenNgayNgayCan'] = "";
		this.filterText['SoPhieuDNXK'] = "";
		var index = 0;
		let res = this.dungChungService.layDanhSachLoaiPhieu(1).subscribe(res => {
			if (res && res.status == 1) {
				this.optionLoaiPhieu = res.data;
				this.filterGroupDataChecked['LoaiPhieu'] = this.optionLoaiPhieu.map(a => {
					index = index + 1;
					return {
						id: index,
						name: a.Ten,
						value: a.Id,
						checked: false,
					}
				})
				this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);
			} else {
				this.layoutUtilsService.showErorr("Không tải được danh sách loại phiếu");
			}
		})
		if (this.flagTab == ConstantsExport.TAB_INTERNAL_EXPORT) {
			merge(this.sort.sortChange)
				.pipe(
					tap(() => {
						this.loadKhoXuatKhoDSDN();
						this.forcusEvents();
					})
				)
				.subscribe();
		} else if (this.flagTab == ConstantsExport.TAB_SELL_EXPORT) {
			merge(this.sort2.sortChange)
				.pipe(
					tap(() => {
						this.loadKhoXuatKhoDSDN__XuatBH();
						this.forcusEvents();
					})
				)
				.subscribe();
		} else if (this.flagTab == ConstantsExport.TAB_SUPPLIER_EXPORT) {
			merge(this.sort3.sortChange)
				.pipe(
					tap(() => {
						this.loadSupplierReturnType();
						this.forcusEvents();
					})
				)
				.subscribe();
		}
		this.showColumnsInTable();
		this.applySelectedColumns();

		if (this.flagTab == ConstantsExport.TAB_INTERNAL_EXPORT) {
			this.dataSource = new KhoXuatKhoPageDataSource(this.KhoXuatKhoService);
			this.dataSource.entitySubject.subscribe(res => {
				this.listHangHoaDaChon = [];
				this.KhoXuatKhoResult = res;
				this.tmpKhoXuatKhoResult = []
				if (this.KhoXuatKhoResult != null) {
					for (let i = 0; i < this.KhoXuatKhoResult.length; i++) {
						let tmpElement = new KhoXuatKhoDeNghi();
						tmpElement.copy(this.KhoXuatKhoResult[i])
						this.tmpKhoXuatKhoResult.push(tmpElement);
					}
					this.tmpKhoXuatKhoResult.forEach(x => {
						let index = this.danhSachId.findIndex(a => a == x.IdCtDn);
						if (index > -1) this.listHangHoaDaChon.push(x);
						if (this.listHangHoaDaChon.findIndex(a => a.IdCtDn == x.IdCtDn) > -1) {
							this.selectionPDN.select(x);
						}
					});
					var lTemp = [];
					lTemp = this.group_by_dnxk(this.tmpKhoXuatKhoResult);
					this.tmpKhoXuatKhoResult = [...lTemp];
				}
				this.loading = false;
				this.changeDetect.detectChanges();
			});
			this.loadKhoXuatKhoDSDNFirstPage();
		} else if (this.flagTab == ConstantsExport.TAB_SELL_EXPORT) {
			this.dataSource2 = new KhoXuatKhoPageDataSource(this.KhoXuatKhoService);
			this.dataSource2.entitySubject.subscribe(res => {
				this.listHangHoaDaChon = [];
				this.KhoXuatKhoResult2 = res;
				this.tmpKhoXuatKhoResult2 = []
				if (this.KhoXuatKhoResult2 != null) {
					for (let i = 0; i < this.KhoXuatKhoResult2.length; i++) {
						let tmpElement = new KhoXuatKhoDeNghi();
						tmpElement.copy(this.KhoXuatKhoResult2[i])
						this.tmpKhoXuatKhoResult2.push(tmpElement);
					}
					this.tmpKhoXuatKhoResult2.forEach(x => {
						let index = this.danhSachId.findIndex(a => a == x.IdCtDn);
						if (index > -1) {
							this.listHangHoaDaChon.push(x);
						}
						if (this.listHangHoaDaChon.findIndex(a => a.IdCtDn == x.IdCtDn) > -1) {
							this.selectionPDN.select(x);
						}
					});
					var lTemp = [];
					lTemp = this.groupByRequestFormOfPurchaseOrder();
					this.tmpKhoXuatKhoResult2 = [...lTemp];
				}
				this.loading2 = false;
				this.changeDetect.detectChanges();
			});
			this.loadKhoXuatKhoDSDNFirstPage__XuatBH();
		} else if (this.flagTab == ConstantsExport.TAB_SUPPLIER_EXPORT) {
			this.dataSource3 = new KhoXuatKhoPageDataSource(this.KhoXuatKhoService);
			this.dataSource3.entitySubject.subscribe(res => {
				this.listHangHoaDaChon = [];
				this.KhoXuatKhoResult3 = res;
				this.tmpKhoXuatKhoResult3 = []
				if (this.KhoXuatKhoResult3 != null) {
					for (let i = 0; i < this.KhoXuatKhoResult3.length; i++) {
						let tmpElement = new KhoXuatKhoDeNghi();
						tmpElement.copy(this.KhoXuatKhoResult3[i])
						this.tmpKhoXuatKhoResult3.push(tmpElement);
					}
					this.tmpKhoXuatKhoResult3.forEach(x => {
						let index = this.danhSachId.findIndex(a => a == x.IdCtDn);
						if (index > -1) this.listHangHoaDaChon.push(x);
						if (this.listHangHoaDaChon.findIndex(a => a.IdCtDn == x.IdCtDn) > -1) {
							this.selectionPDN.select(x);
						}
					});
					var lTemp = [];
					lTemp = this.group_by_dnxk(this.tmpKhoXuatKhoResult3);
					this.tmpKhoXuatKhoResult3 = [...lTemp];
				}
				this.loading3 = false;
				this.changeDetect.detectChanges();
			});
			this.loadSupplierReturnTypeFirstPage();
		}
	}
	tabChange(event: MatTabChangeEvent) {
		this.flagTab = Number(event.index);
		if (this.flagTab == ConstantsExport.TAB_INTERNAL_EXPORT) {
			this.loadKhoXuatKhoDSDNFirstPage();
		} else if (this.flagTab == ConstantsExport.TAB_SELL_EXPORT) {
			this.loadKhoXuatKhoDSDNFirstPage__XuatBH();
		} else if (this.flagTab == ConstantsExport.TAB_SUPPLIER_EXPORT) {
			this.loadSupplierReturnType();
		}
		this.changeDetect.detectChanges();
	}
	ngAfterViewInit() {
		this.changeDetect.detectChanges();
	}
	isTrueButton(ROLENUMBER: number) {
		if (this.LIST_ROLES_USER.findIndex(x => x == ROLENUMBER) > -1) {
			return true;
		}
		return false;
	}
	getFirstDay_LastDay(b_firstday) {
		var date = new Date(), y = date.getFullYear(), m = date.getMonth();
		var firstDay = new Date(y, m, 1);
		var lastDay = new Date(y, m + 1, 0);
		var curent = new Date();
		return b_firstday ? this.datePipe.transform(firstDay, 'dd/MM/yyyy') : this.datePipe.transform(curent, 'dd/MM/yyyy');
	}
	/** SELECTION */
	isAllSelected() {
		const numSelected = this.selectionPDN.selected.filter(x => this.danhSachId.findIndex(a => a == x.IdCtDn) == -1).length;
		const numRows = this.tmpKhoXuatKhoResult.filter(x => this.danhSachId.findIndex(a => a == x.IdCtDn) == -1).length;
		return numSelected === numRows;
	}
	/** Selects all rows if they are not all selected; otherwise clear selection. */
	masterToggle() {
		if (this.isAllSelected()) {
			this.selectionPDN.selected.filter(x => this.danhSachId.findIndex(a => a == x.IdCtDn) == -1).forEach(row => {
				let index = this.listHangHoaDaChon.findIndex(x => x.IdCtDn == row.IdCtDn);
				if (index > -1) {
					this.listHangHoaDaChon.splice(index, 1);
				}
				this.selectionPDN.deselect(row);
			});
		} else {
			this.tmpKhoXuatKhoResult.filter(x => this.danhSachId.findIndex(a => a == x.IdCtDn) == -1).forEach(row => {
				this.selectionPDN.select(row);
				if (this.listHangHoaDaChon.findIndex(x => x.IdCtDn == row.IdCtDn) == -1) {
					this.listHangHoaDaChon.push(row);
				}
			});
		}
	}
	loadKhoXuatKhoDSDN() {
		this.loading = true;
		this.selectionPDN.clear();
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			0,
			10,
			this.filterGroupData,
			true
		);

		this.dataSource.loadKhoXuatKhoDNs(queryParams);
	}
	loadKhoXuatKhoDSDNFirstPage() {
		this.loading = true;
		this.selectionPDN.clear();
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			0,
			10,
			this.filterGroupData,
			true
		);

		this.dataSource.loadKhoXuatKhoDNs(queryParams);
	}
	loadKhoXuatKhoDSDN__XuatBH() {
		this.loading2 = true;
		this.selectionPDN.clear();
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort2.direction,
			this.sort2.active,
			0,
			10,
			this.filterGroupData,
			true
		);

		this.dataSource2.loadKhoXuatKhoDNs__XuatBH(queryParams);
	}
	loadKhoXuatKhoDSDNFirstPage__XuatBH() {
		this.loading2 = true;
		this.selectionPDN.clear();
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort2.direction,
			this.sort2.active,
			0,
			10,
			this.filterGroupData,
			true
		);

		this.dataSource2.loadKhoXuatKhoDNs__XuatBH(queryParams);
	}
	loadSupplierReturnType() {
		this.loading3 = true;
		this.selectionPDN.clear();
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort3.direction,
			this.sort3.active,
			0,
			10,
			this.filterGroupData,
			true
		);

		this.dataSource3.loadSupplierReturnType(queryParams);
	}
	loadSupplierReturnTypeFirstPage() {
		this.loading3 = true;
		this.selectionPDN.clear();
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort3.direction,
			this.sort3.active,
			0,
			10,
			this.filterGroupData,
			true
		);

		this.dataSource3.loadSupplierReturnType(queryParams);
	}
	/** FILTRATION */
	filterConfiguration(): any {
		const filter: any = {};
		filter.IdNCC = "" + this.IdNCC;
		filter.FullSearch = this.kwSearch ? this.kwSearch : "";
		filter.TuNgayCan = this.filterText['TuNgayCan'] ? moment(this.filterText['TuNgayCan']).format("DD/MM/YYYY") : "";
		filter.DenNgayCan = this.filterText['DenNgayCan'] ? moment(this.filterText['DenNgayCan']).format("DD/MM/YYYY") : "";
		filter.TuNgayDNXK = this.filterText['TuNgayDNXK'] ? moment(this.filterText['TuNgayDNXK']).format("DD/MM/YYYY") : "";
		filter.DenNgayDNXK = this.filterText['DenNgayDNXK'] ? moment(this.filterText['DenNgayDNXK']).format("DD/MM/YYYY") : "";
		//filter.XuatDiXuLy = this.isXuatDiXuLy ? 'YES' : 'NO';
		filter.ExportId = this.data.ExportId || '';
		return filter;
	}
	//Apply selected Column
	IsAllColumnsChecked() {
		const numSelected = this.selectedColumns.selected.length;
		const numRows = this.availableColumns.length;
		return numSelected === numRows;
	}
	CheckAllColumns() {
		if (this.IsAllColumnsChecked()) {
			this.availableColumns.forEach(row => { if (!row.alwaysChecked) this.selectedColumns.deselect(row); });
		} else {
			this.availableColumns.forEach(row => this.selectedColumns.select(row));
		}
	}
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		;
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	menuChange(e: any, type: 0 | 1 = 0) {
		this.layoutUtilsService.menuSelectColumns_On_Off();
	}
	f_convertDate(v: any = "") {
		let a = v === "" ? new Date() : new Date(v);
		return a.getFullYear() + "-" + ("0" + (a.getMonth() + 1)).slice(-2) + "-" + ("0" + (a.getDate())).slice(-2) + "T00:00:00.0000000";
	}
	minMaxDate(p_Val: any, flag?: number) {
		if (flag == 0) //tu ngay dang selected
			this.minDate = this.f_convertDate(p_Val._d);
		else
			this.maxDate = this.f_convertDate(p_Val._d);
		let d1 = new Date(this.minDate);
		let d2 = new Date(this.maxDate);
		if (d1.getTime() > d2.getTime())
			this.maxDate = this.f_convertDate(d1.getDate() + 1);
		this.loadKhoXuatKhoDSDN();
	}
	ValidateChangeNumberEvent(columnName: string, item: any, event: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == '.') {
				count += 1;
			}
		}
		var regex = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	getFormatDate(v: string = '') {
		if (v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	getNameOfTinhTrang(tinhtrang: number) {
		if (tinhtrang == 0)
			return 'Chưa duyệt';
		else if (tinhtrang == 1)
			return 'Đã duyệt';
		else if (tinhtrang == 2)
			return 'Không duyệt';
		else if (tinhtrang == 4)
			return 'Chờ kiểm tra';
		else if (tinhtrang == 5)
			return 'Đang kiểm tra';
		else if (tinhtrang == 6)
			return 'Đã kiểm tra';
		return '';
	}
	canDeleteOrUpdate(item: any) {
		if (item != undefined && item.Tinhtrang != 1 && item.Tinhtrang != 5 && item.Tinhtrang != 6)
			return true;
		return false
	}
	asyncCanDeleteOrUpdate(item: any) {
		if (this.canDeleteOrUpdate(item))
			return new BehaviorSubject<boolean>(true);
		return new BehaviorSubject<boolean>(false);
	}
	forcusEvents() {
		if (this.focus != null && this.focus != undefined) {
			// this.focus.first.nativeElement.focus();
			this.changeDetect.detectChanges();
		}
	}
	public onKeydownMain(event: KeyboardEvent) {
		//Tham khảo keyCode của event theo link: https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
		// if (event.altKey && event.keyCode == 78) {
		// 	this.addPhieuKhoXuatKho();
		// }
	}
	//Filter on Grid
	removeText(col) {
		this.filterText[col] = "";
		this.loadKhoXuatKhoDSDN();
		this.forcusEvents();
	}
	getTitle() {
		return 'DANH SÁCH MẶT HÀNG ĐỀ NGHỊ XUẤT KHO';
	}
	back(__action: boolean = false) {
		var attachedDocuments = [];
		let tmp: KhoXuatKhoChiTiet[] = [];
		if (__action) {
			this.listHangHoaDaChon.filter(x => !x["Parent"]).forEach(x => {
				if (true) {
					var amountOfConversion = Number(x.SoLuongQuiDoi) - Number(x.SoLuongThucXuat);
					if (!amountOfConversion) amountOfConversion = 0;
					let item = new KhoXuatKhoChiTiet();
					item.IdHh = x.IdHH;
					item.TenHH = x.TenHH;
					item.MaHH = x.MaHH;
					item.Dvt = x.Dvt;
					item.TenDvt = x.TenDvt;
					item.Soluongdn = x.SoLuongQuiDoi;
					item.DvtQuiDoi = x.DvtQuiDoi;
					item.SoLuongQuiDoi = amountOfConversion;
					item.SLDN = x.SoLuongQuiDoi;
					item.SoPhieuDNXK = x.SoPhieuDNXK;
					item.QuyCach = x.QuyCach;
					item.SLTon = x.SLTon;
					item.Soluongthucnhan = x.SLTon;
					item.TiLeQuiDoi = x.TiLeQuiDoi;
					item.Ghichu = x.GhiChu;
					item.Soluongthucxuat = 0;
					item.IdCTDN = x.IdCtDn;
					item.IdPhieuDHB = x.IdPhieuDHB;
					item.DatHangCtId = x.DatHangCtId;
					item.IdDNXK = x.IdDNXK;
					item.IdKho = x.IdKhoDefault ? x.IdKhoDefault : 0;
					item.SoPhieuDHB = x.SoPhieuDHB;
					item.IdKH = x.IdKH;
					item.MaKH = x.MaKH;
					item.TenKH = x.TenKH;
					item.DiaChi = x.DiaChi;
					item.PartsUsed = x.PartsUsed;
					item.NotesExport = "";
					item.reqMachine = x.ReqMachine;
					item.DienGiaiMaster = x.GhiChu;
					item.SupplierCode = x.SupplierCode;
					item.SupplierName = x.SupplierName;
					item.SupplierAddress = x.SupplierAddress;
					item.Receiver = x.Receiver;
					item.AddressReceiveProduct = x.AddressReceiveProduct;
					item.Reason = x.Reason;
					item.UsingDeparmentId = x.UsingDeparmentId;
					item.UsingDivisionId = x.UsingDivisionId;
					item.SoLoYeuCau = x.SoLoYeuCau;
					tmp.push(item);

					if (x.AttachedDocuments && !attachedDocuments.includes(x.AttachedDocuments))
						attachedDocuments.push(x.AttachedDocuments);
				}
			});
		}
		this.dialogRef2.close({
			action: __action,
			list: tmp,
			type: this.flagTab,
			attachedDocuments: attachedDocuments.filter(x => x != null && x.Name)
		});
	}
	checkIdDSDN(tmp: any, id: any) {
		let isTrue = false;
		tmp.forEach(x => {
			if (+x == id) {
				isTrue = true;
			}
		});
		return isTrue;
	}
	getItemCssClassByStatus(status: any): string {
		switch (status) {
			case false:
				return 'pdnmh_dahuy';
			case true:
				return 'pdnmh_success';
			default:
				return 'success';
		}
	}
	setDisabled(item: any) {
		if (item.TinhTrang == 'KHOPDNXK_CHODUYET') {
			return false;
		}
		return true;
	}
	addPhieuDeNghiCT() {
		// Kiểm tra nếu không có hàng hóa nào được chọn
		if (this.listHangHoaDaChon.filter(x => !x["Parent"]).length === 0) {
			const message = 'Vui lòng chọn hàng hóa từ danh sách bên dưới.';
			this.layoutUtilsService.showErorr(message);
			return;
		}
	
		// Lấy danh sách chi tiết không có Parent
		const details = this.listHangHoaDaChon.filter(x => !x["Parent"]).map(x => Number(x.IdCtDn));
	
		// Tạo payload request
		const requestPayload = {
			type: ConstantsExport.LOCK_REQXUATKHO,
			details: details
		};
	
		// Gửi yêu cầu kiểm tra khóa chi tiết và xử lý phản hồi
		this.dungChungService.getInfoLockRequestForm(requestPayload).subscribe(
			response => {
				if (!response || response.status === 0) {
					if (response && response.data && response.data.length > 0) {
						// Hiển thị thông báo lỗi nếu phản hồi không thành công và có dữ liệu
						this.layoutUtilsService.showErorr(response.error.message || 'Lỗi không xác định');
						// Lọc bỏ những chi tiết bị khóa ra khỏi danh sách
						this.listHangHoaDaChon = this.listHangHoaDaChon.filter(x => !x["Parent"] && !response.data.includes(x.IdCtDn));
					}
				}
				// Quay lại trang trước đó
				this.back(true);
			},
			error => {
				// Xử lý lỗi bất ngờ
				this.layoutUtilsService.showErorr('Đã xảy ra lỗi không mong muốn.');
			}
		);
	}
	
	mergeArr(arr1: any, arr2: any) {
	}
	// isChecked(row: any){
	// 	let index = this.listHangHoaDaChon.findIndex(x => x.IdHH == row.IdHH && x.IdCtDn == row.IdCtDn);
	// 	if(index > -1){
	// 		this.selectionPDN.select(row);
	// 	}else{
	// 		this.selectionPDN.deselect(row);
	// 	}
	// 	return index > -1;
	// }
	// selectionPDNToggle(event, row: any){
	// 	this.selectionPDN.toggle(row);
	// 	if(event.checked){
	// 		this.listHangHoaDaChon.push(row);
	// 	}else{
	// 		let ind = this.listHangHoaDaChon.findIndex(x => x.IdHH == row.IdHH  && x.IdCtDn == row.IdCtDn);
	// 		if(ind > -1){
	// 			this.listHangHoaDaChon.splice(ind,1);
	// 		}
	// 	}
	// }
	disableSLTon(row: any) {
		if (row.SLTon == 0 || row.SLTon == null) return true;
		return false;
	}
	showAllList(event) {
		if (event.checked) {
			this.showAll = true;
		} else {
			this.showAll = false;
		}
		this.loadKhoXuatKhoDSDN();
		this.changeDetect.detectChanges();
	}
	isDisableAll() {
		for (let i = 0; i < this.allRecordSelect.length; i++) {
			if (this.disableSLTon(this.allRecordSelect[i]) == false) {
				return false;
			}
		}
		return true;
	}
	toggleRow(row: KhoXuatKhoDeNghi) {
		if (!row.IsCheckboxDisabled){
			this.selectionPDN.toggle(row);
			var isChecked = this.selectionPDN.isSelected(row);
			if (isChecked) {
				if (this.listHangHoaDaChon.findIndex(a => a.IdCtDn == row.IdCtDn) == -1)
					this.listHangHoaDaChon.push(row);
			} else {
				let index = this.listHangHoaDaChon.findIndex(a => a.IdCtDn == row.IdCtDn);
				if (index > -1)
					this.listHangHoaDaChon.splice(index, 1);
			}
		}
		this.changeDetect.detectChanges();
	}
	disabledRow(row: KhoXuatKhoDeNghi) {
		return this.danhSachId.findIndex(x => x == row.IdCtDn) > -1;
	}
	disabledAllRow() {
		let count = 0;
		this.selectionPDN.selected.forEach(x => {
			if (this.disabledRow(x)) {
				count++;
			}
		})
		return count == this.tmpKhoXuatKhoResult.length;
	}
	selectionPDNHasValue() {
		return this.selectionPDN.hasValue() && this.selectionPDN.selected.length > 0;
	}
	// .. Điều chỉnh hàm format
	f_number(item: any = "0.00000") {
		return FunctionPublic.F_NUMBER_DYNAMIC(item, FunctionPublic.MAX_POINT);
	}

	//#region Filter function
	SelectAll(event, col) {
		if (event.checked) {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = true;
			});
		}
		else {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = false;
			});
		}
	}
	isColumnSelectAll(col) {
		if (this.filterGroupDataCheckedFake[col]) {
			let lst_checked = this.filterGroupDataCheckedFake[col].filter(opt => opt.checked).map(opt => opt.value);
			if (lst_checked) {
				if (lst_checked.length != this.filterGroupDataCheckedFake[col].length) {
					return false;
				}
				else {
					return true;
				}
			}
			else {
				return false;
			}
		}
		return false;
	}
	LoadDataDropFilter(col) {
		this.tmpfilterText = Object.assign({}, this.filterText);
		if (this.filterGroupDataChecked && this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col] && this.filterGroupDataChecked[col]) {
			this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
		}
	}
	// isSelect : true list chon | false là nhap text
	disableDoneButton(col, isSelect = true) {
		let countChecked = 0;
		if (isSelect) {
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				for (var elementFake of this.filterGroupDataCheckedFake[col]) {
					if (elementFake.checked) {
						countChecked++;
					}
				}
			}
			if (countChecked > 0) {
				this.disableButtonFilter[col] = false;
			}
			else {
				this.disableButtonFilter[col] = true;
			}
		} else {
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				if (this.filterGroupDataCheckedFake[col].length > 0) {
					this.disableButtonFilter[col] = false;
				}
				else {
					this.disableButtonFilter[col] = true;
				}
			}
		}
	}
	showClearAllButton() {
		let _count = 0;
		for (var key in this.filterGroupArray) {
			if (this.filterGroupArray.hasOwnProperty(key)) {
				if (this.filterGroupArray[key]) {
					let _arrflt = this.filterGroupArray[key].filter(opt => opt.checked);
					if (_arrflt.length == 0 && this.filterGroupArray[key].length == 1) {
						_arrflt = this.filterGroupArray[key].filter(opt => opt);
					}
					_count += _arrflt ? _arrflt.length : 0;
				}
			}
		}
		let _text = "";
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				_text += this.filterText[key];
			}
		}
		if (_count > 0 || _text) {
			this.isClearAll = true;
		}
		else {
			this.isClearAll = false;
		}
	}
	filterHead(col, isSelect = true) {
		if (isSelect) {
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				for (var elementFake of this.filterGroupDataCheckedFake[col]) {
					let index = this.filterGroupDataChecked[col].findIndex(x => x.id == elementFake.id);
					if (index > -1)
						this.filterGroupDataChecked[col][index].checked = elementFake.checked;
				}
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = this.filterGroupDataCheckedFake[col]
					.filter(opt => opt.checked);
				this.filterGroupData[col] = this.filterGroupDataCheckedFake[col]
					.filter(opt => opt.checked).map(op => op.value);
				//this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
				this.tmpfilterText[col] = '';
			}
			this.filterText = Object.assign({}, this.tmpfilterText);
			if (this.filterText) {
				this.filterConfiguration();
			}
			this.flagTab == 0 ? this.loadKhoXuatKhoDSDNFirstPage() : this.loadKhoXuatKhoDSDNFirstPage__XuatBH();
			this.isClearAll = this.checkFilterHasValue(this.filterGroupDataChecked, 'ALL');
			//this.filterGroupDataCheckedFake[col] = this.filterGroupDataCheckedFake[col];
		} else {
			if (this.filterGroupDataCheckedFake) {
				if (!this.filterGroupDataCheckedFake[col]) {
					this.remove('', col, false);
				} else {
					this.filterGroupData[col] = [];
					this.filterGroupArray[col] = [this.filterGroupDataCheckedFake[col]];
					this.filterGroupData[col] = [this.filterGroupDataCheckedFake[col]];
					if (this.filterGroupData[col])
						this.tmpfilterText[col] = '';
				}
			}
			this.filterText = Object.assign({}, this.tmpfilterText);
			if (this.filterText) {
				this.filterConfiguration();
			}
			this.flagTab == 0 ? this.loadKhoXuatKhoDSDNFirstPage() : this.loadKhoXuatKhoDSDNFirstPage__XuatBH();
			this.isClearAll = this.checkFilterHasValue(this.filterGroupDataCheckedFake, col, false);
			this.filterGroupDataCheckedFake[col] = '';
		}
	}
	remove(item, col, isSelect = true) {
		if (isSelect) {
			let _index = this.filterGroupDataChecked[col].findIndex(x => x.value == item.value);
			if (_index > -1) {
				this.filterGroupDataChecked[col][_index].checked = false;
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = this.filterGroupDataChecked[col]
					.filter(opt => opt.checked);
				this.filterGroupData[col] = this.filterGroupDataChecked[col]
					.filter(opt => opt.checked).map(op => op.value);
				if (this.filterGroupData[col] != null && this.filterGroupData[col].length == 0) {
					this.filterGroupData[col] = null
					this.filterText[col] = '';
					this.disableButtonFilter[col] = true;
				}
				this.flagTab == 0 ? this.loadKhoXuatKhoDSDNFirstPage() : this.loadKhoXuatKhoDSDNFirstPage__XuatBH();
			}
		} else {
			let _index = this.filterGroupDataCheckedFake[col].length;
			if (_index > -1) {
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupData[col] = [];
				if (this.filterGroupData[col] != null && this.filterGroupData[col].length == 0) {
					this.filterGroupData[col] = null
					this.filterText[col] = '';
					this.disableButtonFilter[col] = true;
				}
				this.filterGroupDataCheckedFake[col] = '';
				this.flagTab == 0 ? this.loadKhoXuatKhoDSDNFirstPage() : this.loadKhoXuatKhoDSDNFirstPage__XuatBH();
			}
		}
	}
	Clear() {
		this.filterGroupData = [];
		this.filterGroupArray = [];
		for (var key in this.filterGroupDataChecked) {
			if (this.filterGroupDataChecked.hasOwnProperty(key)) {
				if (this.filterGroupDataChecked[key]) {
					this.filterGroupDataChecked[key].forEach(element => {
						element.checked = false;
					});
					this.disableButtonFilter[key] = true;
				}
			}
		}
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				this.filterText[key] = "";
			}
		}
		this.isClearAll = false;
		this.flagTab == 0 ? this.loadKhoXuatKhoDSDNFirstPage() : this.loadKhoXuatKhoDSDNFirstPage__XuatBH();
		this.forcusEvents();
	}
	checkFilterHasValue(data, col, isSelect = true) {
		let _count = 0;
		if (isSelect) {
			if (col == 'ALL' && data) {//check all column
				for (var key in data) {
					if (data.hasOwnProperty(key)) {
						if (data[key]) {
							let _arrflt = data[key].filter(opt => opt.checked);
							_count += _arrflt ? _arrflt.length : 0;
						}
					}
				}
				let _text = "";
				for (var key in this.filterText) {
					if (this.filterText.hasOwnProperty(key)) {
						_text += this.filterText[key];
					}
				}
				if (_count > 0 || _text) {
					return true;
				}
			}
			else {//check in 1 column
				if (data && data[col]) {
					let _arrflt = data[col].filter(opt => opt.checked);
					_count += _arrflt ? _arrflt.length : 0;
				}
				if (_count > 0) {
					return true;
				}
			}
		} else {
			if (data && data[col] && data[col].length > 0) {
				if (data[col].length > 0) {
					return true;
				}
			}
		}
		return false;
	}
	filterGroupWithTextFilter(columnName: string) {
		let search = this.tmpfilterText[columnName]
		if (!search) {
			this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].map(x => Object.assign({}, x));
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].filter(
			ts => ts.name.toLowerCase().indexOf(search) > -1)
		this.changeDetect.detectChanges();
	}
	//#endregion Filter function
	formatDate(date) {
		return moment(date).format("DD/MM/YYYY");
	}
	clearMinMaxDate() {
		this.top = null;
		this.down = null;
		this.changeDetect.detectChanges();
	}
	group_by_dnxk(data) {
		var lSchedule = [];
		var lDNXK = [];
		data.forEach(x => {
			var index = lDNXK.findIndex(a => a.IdPhieuDNXK == x.IdPhieuDNXK);
			if (index == -1) {
				var rObj = {};
				rObj["Parent"] = true;
				rObj["IdPhieuDNXK"] = x.IdPhieuDNXK;
				rObj["SoPhieuDNXK"] = x.SoPhieuDNXK;
				rObj["NgayLapPhieuDNXK"] = x.NgayLapPhieuDNXK;
				rObj["isShow"] = false;
				rObj["DienGiai"] = x.PartsUsed ? x.PartsUsed : x.TenKhuVuc;
				lDNXK.push(rObj);
			}
			else {
				var dienGiai = x.PartsUsed ? x.PartsUsed : x.TenKhuVuc;
				if (lDNXK[index]["DienGiai"] && lDNXK[index]["DienGiai"].indexOf(dienGiai) == -1) {
					if (lDNXK[index]["DienGiai"].length > 0) lDNXK[index]["DienGiai"] += ", ";
					lDNXK[index]["DienGiai"] += dienGiai;
				}
			}
		});
		lDNXK.sort((a, b) => {
			if (a.IdPhieuDNXK > b.IdPhieuDNXK)
				return -1;
			return 1;
		})
		lDNXK.forEach(x => {
			var lChilds = data.filter(a => a.IdPhieuDNXK == x.IdPhieuDNXK);
			if (lChilds.length > 0)
				lChilds.sort((s, x) => {
					if (s.MaHH < x.MaHH)
						return -1;
					return 1;
				});
			lSchedule.push(x);
			lChilds.forEach(a => a.isShow = false);
			lSchedule = lSchedule.concat(lChilds);
		});
		return lSchedule;
	}
	groupByRequestFormOfPurchaseOrder() {
		var groupedRequestForms = [];
		var finalGroupedData = [];
		const exportDetails = this.tmpKhoXuatKhoResult2;

		// Lấy danh sách data cha
		exportDetails.forEach(detail => {
			const parentIndex = groupedRequestForms.findIndex(parent => parent.IdPhieuDNXK === detail.IdPhieuDNXK);
			if (parentIndex === -1) {
				groupedRequestForms.push({
					"Parent": true,
					"IdPhieuDNXK": detail.IdPhieuDNXK,
					"SoPhieuDNXK": detail.SoPhieuDNXK,
					"NgayLapPhieuDNXK": detail.NgayLapPhieuDNXK,
					"isShow": false,
					"NgayCan": detail.NgayCan,
					"PurchaseOrderSys": detail.SoPhieuDHB,
					"PurchaseOrderNFC": detail.CustomerPurchaseOrder,
					"CustomerCode": detail.MaKH,
					"CustomerName": detail.TenKH
				});
			} else {
				const parent = groupedRequestForms[parentIndex];
				groupedRequestForms[parentIndex]["PurchaseOrderSys"] = this.updateFieldIfNew(parent, "PurchaseOrderSys", detail.SoPhieuDHB);
				groupedRequestForms[parentIndex]["PurchaseOrderNFC"] = this.updateFieldIfNew(parent, "PurchaseOrderNFC", detail.CustomerPurchaseOrder);
				groupedRequestForms[parentIndex]["CustomerCode"] = this.updateFieldIfNew(parent, "CustomerCode", detail.MaKH);
				groupedRequestForms[parentIndex]["CustomerName"] = this.updateFieldIfNew(parent, "CustomerName", detail.TenKH);
			}
		});

		// Sort data
		groupedRequestForms.sort((leftData, rightData) => {
			return rightData["IdPhieuDNXK"] - leftData["IdPhieuDNXK"];
		});

		// Ghép data chi tiết vào data cha
		groupedRequestForms.forEach(parent => {
			const detailsOfParent = exportDetails.filter(detail => detail.IdPhieuDNXK === parent.IdPhieuDNXK)
				.map(detail => ({ ...detail, "isShow": false }));

			if (detailsOfParent.length > 0) {
				detailsOfParent.sort((detailA, detailB) => {
					return detailB.IdPhieuDHB - detailA.IdPhieuDHB;
				});
			}
			finalGroupedData = [...finalGroupedData, parent, ...detailsOfParent];
		});

		return finalGroupedData;
	}

	updateFieldIfNew(parent, field, detailValue) {
		const values = parent[field].split(",").map(str => str.trim());

		if (detailValue && !values.includes(detailValue)) {
			if (parent[field]) parent[field] += ", ";
			parent[field] += detailValue;
		}

		return parent[field];
	}

	get_index(item: any) {
		if (item.Parent) {
			var lParent = this.tmpKhoXuatKhoResult2.filter(x => x["Parent"] == true);
			return lParent.indexOf(item) + 1;
		}
		return '';
	}
	get_index_1(item: any) {
		if (item.Parent) {
			var lParent = this.tmpKhoXuatKhoResult.filter(x => x["Parent"] == true);
			return lParent.indexOf(item) + 1;
		}
		return '';
	}
	loadIndexList(item: any, data: KhoXuatKhoDeNghi[] = []) {
		if (item.Parent) {
			var lParent = data.filter(x => x["Parent"] == true);
			return lParent.indexOf(item) + 1;
		}
		return '';
	}

	toggleAllSelectedChilds(event: any, row: any){
		if (this.flagTab == this.TAB_INTERNAL_EXPORT) {
			return this.handleToggleAllSelectedChilds(event, row, (item, row) => item.IdPhieuDNXK == row.IdPhieuDNXK && !item.IsCheckboxDisabled);
		} else if (this.flagTab == this.TAB_SELL_EXPORT) {
			return this.handleToggleAllSelectedChilds(event, row, (item, row) => item.IdPhieuDNXK == row.IdPhieuDNXK && !item.IsCheckboxDisabled);
		} else if (this.flagTab == this.TAB_SUPPLIER_EXPORT) {
			return this.handleToggleAllSelectedChilds(event, row, (item, row) => item.IdPhieuDNXK === row.IdPhieuDNXK && !item.IsCheckboxDisabled);
		}
		return false;
	}

	handleToggleAllSelectedChilds(event: any, row: any, conditionFn: any){
		const source = this.getDateSource();
		const checked = event.checked;
		const removes = [];

		// .. Chỉ check cho dòng parent được chọn
		if (row['Parent']){
			const selected = source.filter(x => conditionFn(x, row) && !x["Parent"]);
			// .. Kiểm tra xem là check hay non-check
			if (checked){
				selected.forEach(item => {
					this.selectionPDN.select(item);
					if (this.listHangHoaDaChon.findIndex(a => a.IdCtDn == item.IdCtDn) == -1)
						this.listHangHoaDaChon.push(item);
				});
			} else {
				selected.forEach(item => {
					this.selectionPDN.deselect(item);
					let index = this.listHangHoaDaChon.findIndex(a => a.IdCtDn == item.IdCtDn);
					if (index > -1) removes.push(index);
				});
			}
			// .. Sort và xóa
			if (removes.length > 0) {
				removes.sort((a, b) => {return b - a;});
				removes.forEach(x => { this.listHangHoaDaChon.splice(x, 1);});
			}
		}
		this.changeDetect.detectChanges();
	}

	getDateSource(){
		if (this.flagTab == this.TAB_INTERNAL_EXPORT) {
			return this.tmpKhoXuatKhoResult;
		} else if (this.flagTab == this.TAB_SELL_EXPORT) {
			return this.tmpKhoXuatKhoResult2;
		} else if (this.flagTab == this.TAB_SUPPLIER_EXPORT) {
			return this.tmpKhoXuatKhoResult3;
		}
		return [];
	}

	checkIfAllMatchingRowsSelected(row: any, conditionFn: any){
		const result 	   = this.getDateSource();
		const selectedRows = this.selectionPDN.selected.filter(x => conditionFn(x, row) && !x["Parent"]).length;
		const totalRows    = result.filter(x => conditionFn(x, row) && !x["Parent"]).length;

		if (selectedRows != totalRows && selectedRows == 0) {
			const parentSelected = this.selectionPDN.selected.filter(x => conditionFn(x, row) && x["Parent"]);
			if (parentSelected.length > 0) {
				parentSelected.forEach(x => this.selectionPDN.deselect(x));
			}
		}

		return selectedRows === totalRows && selectedRows > 0;
	}

	isAllSelectedChilds(row: any){
		if (this.flagTab == this.TAB_INTERNAL_EXPORT) {
			return this.checkIfAllMatchingRowsSelected(row, (item, row) => item.IdPhieuDNXK == row.IdPhieuDNXK && !item.IsCheckboxDisabled);
		} else if (this.flagTab == this.TAB_SELL_EXPORT) {
			return this.checkIfAllMatchingRowsSelected(row, (item, row) => item.IdPhieuDNXK == row.IdPhieuDNXK && !item.IsCheckboxDisabled);
		} else if (this.flagTab == this.TAB_SUPPLIER_EXPORT) {
			return this.checkIfAllMatchingRowsSelected(row, (item, row) => item.IdPhieuDNXK === row.IdPhieuDNXK && !item.IsCheckboxDisabled);
		}
		return false;
	}

	isSelectedChilds(row: any){
		if (this.flagTab == this.TAB_INTERNAL_EXPORT) {
			return this.selectionPDN.selected.filter(item => item.IdPhieuDNXK == row.IdPhieuDNXK && !item.IsCheckboxDisabled && !item["Parent"]).length;
		} else if (this.flagTab == this.TAB_SELL_EXPORT) {
			return this.selectionPDN.selected.filter(item => item.IdPhieuDNXK == row.IdPhieuDNXK && !item.IsCheckboxDisabled && !item["Parent"]).length;
		} else if (this.flagTab == this.TAB_SUPPLIER_EXPORT) {
			return this.selectionPDN.selected.filter(item => item.IdPhieuDNXK === row.IdPhieuDNXK && !item.IsCheckboxDisabled && !item["Parent"]).length;
		}
		return false;
	}

	isDisabledParent(row: any){
		if (this.flagTab == this.TAB_INTERNAL_EXPORT) {
			return this.checkDisabledParent(row, (item, row) => item.IdPhieuDNXK == row.IdPhieuDNXK);
		} else if (this.flagTab == this.TAB_SELL_EXPORT) {
			return this.checkDisabledParent(row, (item, row) => item.IdPhieuDNXK == row.IdPhieuDNXK);
		} else if (this.flagTab == this.TAB_SUPPLIER_EXPORT) {
			return this.checkDisabledParent(row, (item, row) => item.IdPhieuDNXK === row.IdPhieuDNXK);
		}
		return false;
	}

	checkDisabledParent(row: any, conditionFn: any){
		const source = this.getDateSource();
		const item = source.filter(x => conditionFn(x, row) && !x["Parent"]);
		const sizeItem = item.length;
		const sizeItemDisabled = item.filter(x => x.IsCheckboxDisabled).length;
		return sizeItem == sizeItemDisabled && sizeItem > 0;
	}

	disabled_row(row: KhoXuatKhoDeNghi) {
		if (this.selectionPDN.selected.filter(x => !x["Parent"]).length == 0) return false;
	}
	disable_tab(tab: number) {
		return tab != this.flagTab; // && this.selectionPDN.selected.length > 0;
	}
	disabled_btn_next() {
		return this.listHangHoaDaChon.filter(x => !x["Parent"]).length == 0;
	}
	setChildOpenParent(row: KhoXuatKhoDeNghi) {
		row.isShow = !row.isShow;
		var l = this.tmpKhoXuatKhoResult.filter(x => x.IdPhieuDNXK == row.IdPhieuDNXK && !x["Parent"]);
		l.forEach(x => x.isShow = !x.isShow);
		this.tmpKhoXuatKhoResult = [...this.tmpKhoXuatKhoResult];
		this.changeDetect.detectChanges();
	}
	setChildOpenParentKH(row: KhoXuatKhoDeNghi) {
		row.isShow = !row.isShow;
		var l = this.tmpKhoXuatKhoResult2.filter(x => x.IdPhieuDNXK == row.IdPhieuDNXK && !x["Parent"]);
		l.forEach(x => x.isShow = !x.isShow);
		this.tmpKhoXuatKhoResult2 = [...this.tmpKhoXuatKhoResult2];
		this.changeDetect.detectChanges();
	}
	setChildOpenParent3(row: KhoXuatKhoDeNghi) {
		row.isShow = !row.isShow;
		var l = this.tmpKhoXuatKhoResult3.filter(x => x.IdPhieuDNXK == row.IdPhieuDNXK && !x["Parent"]);
		l.forEach(x => x.isShow = !x.isShow);
		this.tmpKhoXuatKhoResult3 = [...this.tmpKhoXuatKhoResult3];
		this.changeDetect.detectChanges();
	}

	getListDNXK() {
		return this.tmpKhoXuatKhoResult.map(x => x.SoPhieuDNXK);
	}

	replace(str) {
		if (!str) str = "";
		if (!this.kwSearch) this.kwSearch = "";
		return this.kwSearch.length > 0 ? (str.replace(new RegExp(`(${this.kwSearch})`, 'gi'), '<b>$1</b>')).trim() : str.trim();
	}

	getFullDNXK(IdPhieuDHB: number) {
		let childs_multiple = this.tmpKhoXuatKhoResult2.filter(x => x["IdPhieuDHB"] && x["IdPhieuDHB"] == IdPhieuDHB && x["SoPhieuDNXK"]);
		let childs_unique = [];
		childs_multiple.forEach(_x => {
			//console.log(_x["SoPhieuDNXK"]);
			if (childs_unique.find(_a => _a == _x["SoPhieuDNXK"]) == null) {
				childs_unique.push(_x["SoPhieuDNXK"]);
			}
		})
		if (childs_unique.length > 0) {
			return childs_unique.map(_x => _x).sort((a, b) => {
				let wordA = a.toUpperCase();
				let wordB = b.toUpperCase();
				if (wordA < wordB) return -1;
				if (wordA > wordA) return 1;
				return 0;
			}).join(", ");
		}
		return "";
	}

	onlyUnique(value, index, self) {
		return self.lastIndexOf(value) === index;
	}

	onReloadDataTable(): void {
		const activeTabIndex = this.flagTab || 0;

		if (activeTabIndex == ConstantsExport.TAB_INTERNAL_EXPORT) {
			this.loadKhoXuatKhoDSDNFirstPage();
		} else if (activeTabIndex == ConstantsExport.TAB_SELL_EXPORT) {
			this.loadKhoXuatKhoDSDNFirstPage__XuatBH();
		} else if (activeTabIndex == ConstantsExport.TAB_SUPPLIER_EXPORT) {
			this.loadSupplierReturnTypeFirstPage();
		}
	}
}
